import { cn } from "@/lib/cn";

export function Spinner({
  className,
  label = "Loading",
}: {
  className?: string | undefined;
  label?: string | undefined;
}) {
  return (
    <output
      aria-label={label}
      className={cn(
        "inline-block h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent",
        className,
      )}
    />
  );
}

export function PageSpinner({ label = "Loading" }: { label?: string | undefined }) {
  return (
    <div className="flex min-h-dvh w-full flex-1 flex-col items-center justify-center gap-3 text-ink-faint">
      <Spinner label={label} />
      <p className="text-sm">{label}</p>
    </div>
  );
}
